// extracted by mini-css-extract-plugin
export default {"error":"error-boundary_error__yi1bL","actions":"error-boundary_actions__NQx1M","empty":"error-boundary_empty__lOWFj"};